export const ID = '617b6cf9-1e5f-4474-bb1f-a224c6a8af2c';

export const NAME = 'Facility Group';
